<div class="future-services text-center">
  <div class="future-img">
    <ng-content select="[cardMedia]"></ng-content>
  </div>
  <ng-content select="[cardTitle]"></ng-content>
  <ng-content select="[cardBody]"></ng-content>
</div>
